import ReactDOM from 'react-dom/client';
import { createBrowserRouter, Navigate, RouterProvider } from "react-router-dom";
import App from './App.tsx';
import PermissionGuard from './components/PermissionGuard.tsx';
import MainLayout from './components/MainLayout.tsx';
import Login from './pages/Login.tsx';
import OnboardingPage from './pages/OnboardingPage.tsx';
import BemVindoPage from './pages/BemVindoPage.tsx';
import ConfirmarEmailPage from './pages/ConfirmarEmailPage.tsx';
import EsqueciSenhaPage from './pages/EsqueciSenhaPage.tsx';
import RedefinirSenhaPage from './pages/RedefinirSenhaPage.tsx';
import AceitarConvitePage from './pages/AceitarConvitePage.tsx';
import ResumoDiarioPararPage from './pages/ResumoDiarioPararPage.tsx';
import InstalarPage from './pages/InstalarPage.tsx';
import Dashboard from './pages/Dashboard.tsx';
import ContactsPage from './pages/ContactsPage.tsx';
import OrganizationsPage from './pages/OrganizationsPage.tsx';
import AssinaturasPage from './pages/AssinaturasPage.tsx';
import PipelinePage from './pages/PipelinePage.tsx';
import ChatPage from './pages/ChatPage.tsx';
import UserManagementPage from './pages/UserManagementPage.tsx';
import SystemPromptsPage from './pages/SystemPromptsPage.tsx';
import AgentePage from './pages/AgentePage.tsx';
import ConfiguracoesContaPage from './pages/ConfiguracoesContaPage.tsx';
import HomePage from './pages/HomePage.tsx';
import AssistentePage from './pages/AssistentePage.tsx';
import AssistenteConversasPage from './pages/AssistenteConversasPage.tsx';
import PaginaDeCapturaPage from './pages/PaginaDeCapturaPage.tsx';
import ProductsPage from './pages/ProductsPage.tsx';
import ConnectionsPage from './pages/ConnectionsPage.tsx';
import './index.css';
import NotFoundPage from './pages/NotFoundPage.tsx';
import AgendaPage from './pages/AgendaPage.tsx';
import TarefasPage from './pages/TarefasPage.tsx';
import ChatDashboard from './pages/ChatDashboard.tsx';
import HelpPage from './pages/HelpPage.tsx';
import HelpArticlePage from './pages/HelpArticlePage.tsx';
import HelpManagerPage from './pages/HelpManagerPage.tsx';
import HelpArticleEditorPage from './pages/HelpArticleEditorPage.tsx';
import OnboardingStepsPage from './pages/OnboardingStepsPage.tsx';
import CampaignTemplatesPage from './pages/CampaignTemplatesPage.tsx';
import TemplateEditorPage from './pages/TemplateEditorPage.tsx';
import DisparadorPage from './pages/DisparadorPage.tsx';
import CampanhaPage from './pages/CampanhaPage.tsx';
import GoalsPage from './pages/GoalsPage.tsx';
import TeamsPage from './pages/TeamsPage.tsx';
import TipoUsuarioPage from './pages/TipoUsuarioPage.tsx';
import DealDetailsPage from './pages/DealDetailsPage.tsx';
import BillingPlanPage from './pages/BillingPlanPage';
import EmpresasPage from './pages/EmpresasPage';
import GerenciarEmpresaPage from './pages/GerenciarEmpresaPage.tsx';
import PlanManagementPage from './pages/PlanManagementPage';
import MensagensSistemaPage from './pages/MensagensSistemaPage';
import FuncionalidadesSistemaPage from './pages/FuncionalidadesSistemaPage';
import AssistenteSistemaPage from './pages/AssistenteSistemaPage';
import VisaoGeralSistemaPage from './pages/VisaoGeralSistemaPage';
import SiteSistemaPage from './pages/SiteSistemaPage';
import SugestoesSistemaPage from './pages/SugestoesSistemaPage';
import NovidadesPage from './pages/NovidadesPage.tsx';
/* ReportsPage e CampaignReportsPage saíram do roteador: as duas telas viraram
   relatórios prontos da nova área (/relatorios). Os arquivos seguem no repo até
   o aval para apagar — ver estado-do-redesign.md. */
import RelatoriosPage from './pages/RelatoriosPage.tsx';
import RelatorioModelosPage from './pages/RelatorioModelosPage.tsx';
import RelatorioPainelPage from './pages/RelatorioPainelPage.tsx';
import CamposPersonalizadosPage from './pages/CamposPersonalizadosPage.tsx';
import MotivoPerdaPage from './pages/MotivoPerdaPage.tsx';
import FunilPage from './pages/FunilPage';
import TiposContatoPage from './pages/TiposContatoPage.tsx';
import ModelosDocumentoPage from './pages/ModelosDocumentoPage.tsx';
import TarefasPadraoPage from './pages/TarefasPadraoPage.tsx';
import TiposTarefaPage from './pages/TiposTarefaPage.tsx';
import AtalhosPage from './pages/AtalhosPage.tsx';
import TrilhoQuadroPage from './pages/TrilhoQuadroPage.tsx';
import AnotacoesPage from './pages/AnotacoesPage.tsx';
import AnotacaoEditorPage from './pages/AnotacaoEditorPage.tsx';
import GoogleCalendarCallbackPage from './pages/GoogleCalendarCallbackPage.tsx';
import GoogleLoginCallbackPage from './pages/GoogleLoginCallbackPage.tsx';
import InstagramCallbackPage from './pages/InstagramCallbackPage.tsx';
import TrafegoPagoCallbackPage from './pages/TrafegoPagoCallbackPage.tsx';
import RdStationCallbackPage from './pages/RdStationCallbackPage.tsx';
import AppsPage from './pages/AppsPage.tsx';
import PublicLandingPage from './pages/PublicLandingPage.tsx';
import AnunciosPage from './pages/AnunciosPage.tsx';

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { path: "/", element: <Login /> },
      { path: "login", element: <Login /> },
      { path: "cadastro", element: <OnboardingPage /> },
      /* O guia de boas-vindas de quem acabou de criar a conta (28/10/2026): na
         casca do cadastro, fora do app — o app é a chegada. Exige sessão; a
         própria tela manda ao /login quem não tem. */
      { path: "bem-vindo", element: <BemVindoPage /> },
      { path: "confirmar-email", element: <ConfirmarEmailPage /> },
      { path: "esqueci-senha", element: <EsqueciSenhaPage /> },
      { path: "redefinir-senha", element: <RedefinirSenhaPage /> },
      { path: "aceitar-convite", element: <AceitarConvitePage /> },
      // O "Parar de receber" do resumo diário por e-mail: anônima, o token é da inscrição.
      { path: "resumo-diario/parar", element: <ResumoDiarioPararPage /> },
      // O link que se manda ao cliente para ter o Brik como app no celular.
      { path: "instalar", element: <InstalarPage /> },
      { path: "p/:token", element: <PublicLandingPage /> },
      { path: "integracoes/google/callback", element: <GoogleCalendarCallbackPage /> },
      { path: "login/google", element: <GoogleLoginCallbackPage /> },
      { path: "integracoes/instagram/callback", element: <InstagramCallbackPage /> },
      { path: "integracoes/meta-ads/callback", element: <TrafegoPagoCallbackPage /> },
      { path: "integracoes/rdstation/callback", element: <RdStationCallbackPage /> },
      {
        element: <MainLayout />,
        children: [
          /* Home e assistente ficam FORA do PermissionGuard de propósito: todo
             usuário tem assistente, e o que muda por perfil é o alcance do
             dado, aplicado dentro de cada ferramenta na API. Pelo mesmo motivo
             não registrar "/home" nem "/assistente" no mapa de permissões — com
             o fallback para o caminho-mãe, isso barraria o usuário comum. */
          { path: "home", element: <HomePage /> },
          { path: "assistente", element: <AssistenteConversasPage /> },
          { path: "assistente/:id", element: <AssistentePage /> },
          { path: "primeiros-passos", element: <OnboardingStepsPage /> },
          { path: "plano", element: <PermissionGuard><BillingPlanPage /></PermissionGuard> },
          { path: "help", element: <HelpPage /> },
          { path: "help/article/:id", element: <HelpArticlePage /> },
          { path: "admin/help", element: <PermissionGuard><HelpManagerPage /></PermissionGuard> },
          { path: "admin/help/new", element: <PermissionGuard><HelpArticleEditorPage /></PermissionGuard> },
          { path: "admin/help/edit/:id", element: <PermissionGuard><HelpArticleEditorPage /></PermissionGuard> },
          { path: "novidades", element: <NovidadesPage /> },
          { path: "chat", element: <PermissionGuard><ChatPage /></PermissionGuard> },
          { path: "dashboard", element: <PermissionGuard><Dashboard /></PermissionGuard> },
          { path: "monitoramento", element: <PermissionGuard><ChatDashboard /></PermissionGuard> },
          { path: "pipeline", element: <PermissionGuard><PipelinePage /></PermissionGuard> },
          { path: "pipeline/deal/:id", element: <PermissionGuard><DealDetailsPage /></PermissionGuard> },
          { path: "contacts", element: <PermissionGuard><ContactsPage /></PermissionGuard> },
          /* Organizações usa a permissão de contatos: é o mesmo cadastro de
             quem se atende, e a permissão `organizacoes` não existe na base.
             Ver PUBLIC_ROUTES/permissions em config/permissions.ts. */
          { path: "organizations", element: <PermissionGuard><OrganizationsPage /></PermissionGuard> },
          { path: "assinaturas", element: <PermissionGuard><AssinaturasPage /></PermissionGuard> },
          { path: "anotacoes", element: <AnotacoesPage /> },
          { path: "anotacoes/:id", element: <AnotacaoEditorPage /> },
          { path: "agenda", element: <PermissionGuard><AgendaPage /></PermissionGuard> },
          /* Tarefas não tem permissão própria: são as tarefas de quem está logado.
             Quem é gestor vê as dos outros pelo seletor, e o alcance é validado na API. */
          { path: "tarefas", element: <TarefasPage /> },
          { path: "relatorios", element: <PermissionGuard><RelatoriosPage /></PermissionGuard> },
          /* "Novo relatório" abre a biblioteca de modelos, não uma folha em branco.
             Escolher um modelo leva para /novo/:modelo, que é o painel em edição
             AINDA NÃO SALVO — só vira registro no Salvar, então quem desistir no
             meio não deixa relatório órfão na galeria. */
          { path: "relatorios/novo", element: <PermissionGuard><RelatorioModelosPage /></PermissionGuard> },
          { path: "relatorios/novo/:modelo", element: <PermissionGuard><RelatorioPainelPage /></PermissionGuard> },
          { path: "relatorios/:id", element: <PermissionGuard><RelatorioPainelPage /></PermissionGuard> },
          { path: "relatorios/:id/editar", element: <PermissionGuard><RelatorioPainelPage /></PermissionGuard> },
          /* As duas rotas antigas viram atalho para os prontos equivalentes —
             link salvo e favorito continuam funcionando. Os ids negativos são os
             relatórios do sistema (ver RelatoriosProntos na API). */
          { path: "relatorios/vendas", element: <Navigate to="/relatorios/-1" replace /> },
          { path: "relatorios/campanhas", element: <Navigate to="/relatorios/-3" replace /> },
          { path: "users", element: <PermissionGuard><UserManagementPage /></PermissionGuard> },
          { path: "chat-rules", element: <PermissionGuard><SystemPromptsPage /></PermissionGuard> },
          { path: "chat-rules/:id", element: <PermissionGuard><AgentePage /></PermissionGuard> },
          /* Sem PermissionGuard de propósito: é a conta do próprio usuário.
             NÃO registrar "/configuracoes" no mapa de permissões — com o
             fallback para o caminho-mãe, isso barraria o usuário comum. */
          { path: "configuracoes/conta", element: <ConfiguracoesContaPage /> },
          { path: "products", element: <PermissionGuard><ProductsPage /></PermissionGuard> },
          { path: "connections", element: <PermissionGuard><ConnectionsPage /></PermissionGuard> },
          { path: "apps", element: <PermissionGuard><AppsPage /></PermissionGuard> },
          { path: "equipes", element: <PermissionGuard><TeamsPage /></PermissionGuard> },
          { path: "metas", element: <PermissionGuard><GoalsPage /></PermissionGuard> },
          { path: "tipos-usuario", element: <PermissionGuard><TipoUsuarioPage /></PermissionGuard> },
          { path: "campaign-templates", element: <PermissionGuard><CampaignTemplatesPage /></PermissionGuard> },
          { path: "campaign-templates/:id", element: <PermissionGuard><TemplateEditorPage /></PermissionGuard> },
          { path: "campanhas", element: <PermissionGuard><DisparadorPage /></PermissionGuard> },
          { path: "campanhas/nova", element: <PermissionGuard><CampanhaPage /></PermissionGuard> },
          { path: "campanhas/:id", element: <PermissionGuard><CampanhaPage /></PermissionGuard> },
          { path: "empresas", element: <PermissionGuard><EmpresasPage /></PermissionGuard> },
          { path: "gerenciar-empresa", element: <PermissionGuard><GerenciarEmpresaPage /></PermissionGuard> },
          { path: "pagina-de-captura", element: <PermissionGuard><PaginaDeCapturaPage /></PermissionGuard> },
          { path: "anuncios", element: <PermissionGuard><AnunciosPage /></PermissionGuard> },
          { path: "gerenciar-planos", element: <PermissionGuard><PlanManagementPage /></PermissionGuard> },
          { path: "sistema/mensagens", element: <PermissionGuard><MensagensSistemaPage /></PermissionGuard> },
          { path: "sistema/funcionalidades", element: <PermissionGuard><FuncionalidadesSistemaPage /></PermissionGuard> },
          { path: "sistema/assistente", element: <PermissionGuard><AssistenteSistemaPage /></PermissionGuard> },
          { path: "sistema/visao-geral", element: <PermissionGuard><VisaoGeralSistemaPage /></PermissionGuard> },
          { path: "sistema/site", element: <PermissionGuard><SiteSistemaPage /></PermissionGuard> },
          { path: "sistema/sugestoes", element: <PermissionGuard><SugestoesSistemaPage /></PermissionGuard> },
          { path: "campos-personalizados", element: <PermissionGuard><CamposPersonalizadosPage /></PermissionGuard> },
          { path: "motivos-perda", element: <PermissionGuard><MotivoPerdaPage /></PermissionGuard> },
          { path: "funil", element: <PermissionGuard><FunilPage /></PermissionGuard> },
          { path: "tipos-contato", element: <PermissionGuard><TiposContatoPage /></PermissionGuard> },
          { path: "modelos", element: <PermissionGuard><ModelosDocumentoPage /></PermissionGuard> },
          { path: "tarefas-padrao", element: <PermissionGuard><TarefasPadraoPage /></PermissionGuard> },
          { path: "tarefas-padrao/:id", element: <PermissionGuard><TrilhoQuadroPage /></PermissionGuard> },
          { path: "tipos-tarefa", element: <PermissionGuard><TiposTarefaPage /></PermissionGuard> },
          { path: "atalhos", element: <PermissionGuard><AtalhosPage /></PermissionGuard> },
        ]
      },
      { path: "*", element: <NotFoundPage /> }
    ]
  }
]);

import { ThemeProvider } from './contexts/ThemeContext.tsx';
import { registrarServiceWorker } from './lib/avisoNoAparelho';
import { capturarInstalacao } from './lib/instalarApp';

// O service worker só recebe o aviso de lead novo (Web Push); não guarda cache do app.
registrarServiceWorker();
// O "pode instalar" do Chrome chega uma vez só, no carregamento: guardado para a página /instalar.
capturarInstalacao();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ThemeProvider>
    <RouterProvider router={router} />
  </ThemeProvider>
);